import axios from 'axios';
import { APIConstant } from './APIConstant';
import ApiService from './ApiService';

const getClientList = async () => {
    try {
        const route = `${ApiService.restUrl()}/client/list`;
        const response = await axios.get(route, {
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json',
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching client list:", error);
        throw error.response || error;
    }
};

const createClient = async (client) => {
    try {
        const route = `${ApiService.restUrl()}/client`;
        const response = await axios.post(route, client, {
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json',
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error creating client:", error);
        throw error.response || error;
    }
};

const updateClient = async (client) => {
    try {
        const route = `${ApiService.restUrl()}/client/update`;
        const response = await axios.put(route, client, {
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json',
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error creating client:", error);
        throw error.response || error;
    }
};

const deleteClient = async (client) => {
    try {
        const route = `${ApiService.restUrl()}/client/${client?.id}`
        const response = await axios.delete(route, {
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json',
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error creating client:", error);
        throw error.response || error;
    }
};

const getClientGroupList = async () => {
    try {
        const response = await axios.get(APIConstant.getClientGroupList, {
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json',
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching client group list:", error);
        throw error.response || error;
    }
};

const createClientGroup = async (clientGroup) => {
    try {
        const response = await axios.post(APIConstant.createOrUpdateClientGroup, clientGroup, {
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json',
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error creating client group:", error);
        throw error.response || error;
    }
};

const updateClientGroup = async (clientGroup) => {
    try {
        const response = await axios.put(APIConstant.createOrUpdateClientGroup, clientGroup, {
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json',
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error updating client group:", error);
        throw error.response || error;
    }
};

const deleteClientGroup = async (clientGroup) => {
    try {
        const route = `${ApiService.restUrl()}/client/group/${clientGroup?.id}`
        const response = await axios.delete(route, {
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json',
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error creating client group:", error);
        throw error.response || error;
    }
};


const ClientService = {
    getClientList,
    createClient,
    updateClient,
    deleteClient,
    getClientGroupList,
    createClientGroup,
    updateClientGroup,
    deleteClientGroup
};

export default ClientService;